/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const PaymentPlansDocument = gql`
    query PaymentPlans($locale: String!, $currency: String!) {
  paymentPlans(locale: $locale, currency: $currency) {
    endAt
    type
    renewLink
    activePremium
    trialAvailable
    orderId
    plans {
      planId
      planName
      checkoutUrl
      checkoutUrlTrial
      trial
      trialDays
      currencyAmountByCurrency {
        currency
        amount
        currencySymbol
      }
    }
    paymentOrders {
      id
      currency
      amountMinusDiscount
      planId
      status
      createdAt
      updatedAt
      customerId
      invoiceUrl
    }
    freePlan {
      webPages
      projects
      sharedProjects
      sharedPages
    }
    currencies {
      currencyName
      currencySymbol
    }
  }
}
    `;

/**
 * __usePaymentPlansQuery__
 *
 * To run a query within a React component, call `usePaymentPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentPlansQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function usePaymentPlansQuery(baseOptions: Apollo.QueryHookOptions<PaymentPlansQuery, PaymentPlansQueryVariables> & ({ variables: PaymentPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentPlansQuery, PaymentPlansQueryVariables>(PaymentPlansDocument, options);
      }
export function usePaymentPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentPlansQuery, PaymentPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentPlansQuery, PaymentPlansQueryVariables>(PaymentPlansDocument, options);
        }
// @ts-ignore
export function usePaymentPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentPlansQuery, PaymentPlansQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentPlansQuery, PaymentPlansQueryVariables>;
export function usePaymentPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentPlansQuery, PaymentPlansQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentPlansQuery | undefined, PaymentPlansQueryVariables>;
export function usePaymentPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentPlansQuery, PaymentPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentPlansQuery, PaymentPlansQueryVariables>(PaymentPlansDocument, options);
        }
export type PaymentPlansQueryHookResult = ReturnType<typeof usePaymentPlansQuery>;
export type PaymentPlansLazyQueryHookResult = ReturnType<typeof usePaymentPlansLazyQuery>;
export type PaymentPlansSuspenseQueryHookResult = ReturnType<typeof usePaymentPlansSuspenseQuery>;
export type PaymentPlansQueryResult = Apollo.QueryResult<PaymentPlansQuery, PaymentPlansQueryVariables>;
export const PaymentOrderUnsubscribeDocument = gql`
    mutation PaymentOrderUnsubscribe($orderId: Int!) {
  paymentOrderUnsubscribe(orderId: $orderId)
}
    `;
export type PaymentOrderUnsubscribeMutationFn = Apollo.MutationFunction<PaymentOrderUnsubscribeMutation, PaymentOrderUnsubscribeMutationVariables>;

/**
 * __usePaymentOrderUnsubscribeMutation__
 *
 * To run a mutation, you first call `usePaymentOrderUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentOrderUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentOrderUnsubscribeMutation, { data, loading, error }] = usePaymentOrderUnsubscribeMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePaymentOrderUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<PaymentOrderUnsubscribeMutation, PaymentOrderUnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentOrderUnsubscribeMutation, PaymentOrderUnsubscribeMutationVariables>(PaymentOrderUnsubscribeDocument, options);
      }
export type PaymentOrderUnsubscribeMutationHookResult = ReturnType<typeof usePaymentOrderUnsubscribeMutation>;
export type PaymentOrderUnsubscribeMutationResult = Apollo.MutationResult<PaymentOrderUnsubscribeMutation>;
export type PaymentOrderUnsubscribeMutationOptions = Apollo.BaseMutationOptions<PaymentOrderUnsubscribeMutation, PaymentOrderUnsubscribeMutationVariables>;
export type PaymentPlansQueryVariables = Types.Exact<{
  locale: Types.Scalars['String']['input'];
  currency: Types.Scalars['String']['input'];
}>;


export type PaymentPlansQuery = { __typename?: 'Query', paymentPlans: { __typename?: 'GraphPaymentPlan', endAt?: any | null, type?: string | null, renewLink?: string | null, activePremium: boolean, trialAvailable: boolean, orderId?: number | null, plans: Array<{ __typename?: 'GraphPaymentPlanDTO', planId: number, planName: string, checkoutUrl: string, checkoutUrlTrial?: string | null, trial: boolean, trialDays?: number | null, currencyAmountByCurrency: Array<{ __typename?: 'GraphCurrencyAmountDTO', currency: string, amount?: number | null, currencySymbol: string }> }>, paymentOrders: Array<{ __typename?: 'GraphPaymentOrder', id?: number | null, currency?: string | null, amountMinusDiscount?: number | null, planId?: number | null, status?: number | null, createdAt?: any | null, updatedAt?: any | null, customerId?: string | null, invoiceUrl?: string | null }>, freePlan?: { __typename?: 'GraphPaymentFreePlan', webPages: number, projects: number, sharedProjects: number, sharedPages: number } | null, currencies: Array<{ __typename?: 'GraphCurrency', currencyName: string, currencySymbol: string }> } };

export type PaymentOrderUnsubscribeMutationVariables = Types.Exact<{
  orderId: Types.Scalars['Int']['input'];
}>;


export type PaymentOrderUnsubscribeMutation = { __typename?: 'Mutation', paymentOrderUnsubscribe: boolean };
